import { render, staticRenderFns } from "./hcpBindSuccess.vue?vue&type=template&id=6f69dd42&scoped=true"
import script from "./hcpBindSuccess.vue?vue&type=script&lang=js"
export * from "./hcpBindSuccess.vue?vue&type=script&lang=js"
import style0 from "./hcpBindSuccess.vue?vue&type=style&index=0&id=6f69dd42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69dd42",
  null
  
)

export default component.exports